import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import FilterForm from './FilterForm';

const AddFilterModal = (props) => {
    const { isOpen, closeBehavior, addFilterBehavior } = props;

    return (
        <Modal isOpen={isOpen} className="text-light">
            <ModalHeader>Add Filter</ModalHeader>
            <ModalBody>
                <FilterForm
                    closeBehavior={closeBehavior}
                    addFilterBehavior={addFilterBehavior}
                />
            </ModalBody>
        </Modal>
    );
};

export default AddFilterModal;
